/* eslint-disable no-unused-vars */
import XAccountService from "@/services/data/x-account";

import { SET_DATA, SET_PAGINATION } from "./types";

export async function fetchData({commit}, params) {
  const {data} = await XAccountService.get(params);
  const {accounts, pagination} = data.data;
  commit(SET_DATA, accounts);
  commit(SET_PAGINATION, pagination);
  return accounts;
}

export async function importData({commit}, params) {
  const {data} = await XAccountService.import(params);
  return data;
}

export async function exportData({commit}, params) {
  const {data} = await XAccountService.export(params);
  return data;
}

export async function deleteData({commit}, params) {
  const {data} = await XAccountService.delete(params);
  return data;
}

export async function createCheckLiveUidsTask({commit}, {uids}) {
  const {data} = await XAccountService.createCheckLiveUidsTask(uids);
  return data;
}

export async function createCheckLiveFilterTask({commit}, params) {
  const {data} = await XAccountService.createCheckLiveFilterTask(params);
  return data;
}

export async function getCheckLiveTask({commit}, params) {
  const {data} = await XAccountService.getCheckLiveTask(params);
  return data;
}

export async function checkLiveEmailFilter({commit}, params) {
  const {data} = await XAccountService.checkLiveEmailFilter(params);
  return data;
}

export async function fetchById({commit}, id) {
  const {data} = await XAccountService.getById(id);
  return data.data;
}

export async function unassignTag({commit}, params) {
  const {data} = await XAccountService.unassignTag(params);
  return data;
}

export async function unassignTagByFilter({commit}, params) {
  const {data} = await XAccountService.unassignTagByFilter(params);
  return data;
}

export async function getXCookies({commit}) {
  const {data} = await XAccountService.getXCookies();
  return data.data.cookies;
}

export async function setXCookies({commit}, params) {
  const {data} = await XAccountService.setXCookies(params);
  return data;
}

export async function addJobInputs({commit}, {filter, jobPid}) {
  const {data} = await XAccountService.addJobInputs(filter, jobPid);
  return data;
}

export async function countDeletedData({commit}) {
  const {data} = await XAccountService.countDeletedData();
  return data;
}

export async function removeTrash({commit}) {
  const {data} = await XAccountService.removeTrash();
  return data;
}

export async function restoreTrash({commit}) {
  const {data} = await XAccountService.restoreTrash();
  return data;
}
